
export type Language = 'Dutch' | 'English' | 'German' | 'Polish';
export const LanguageValues: Language[] = ['Dutch' , 'English' , 'German' , 'Polish'];

